module.exports = __webpack_public_path__ + "img/blog2.11c59bbb.jpg";